import React from 'react'
import { Box } from '@material-ui/core'
import { t } from 'ttag'
import MaterialReactTable, {
  MaterialReactTableProps,
  MRT_FullScreenToggleButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton,
} from 'material-react-table'
import Hidden from '@material-ui/core/Hidden'
import variables from '../../styles/_variables.scss'
import { darkBlue, darkGray, gray } from '../../styles/material-ui-theme-v2'

interface YumTableProps extends MaterialReactTableProps {
  showFilters?: boolean
}

const YumTable = (props: YumTableProps) => {
  const { showFilters, ...otherProps } = props
  return (
    <MaterialReactTable
      autoResetPageIndex={false}
      muiTablePaperProps={{ elevation: 0 }}
      enableRowNumbers
      rowNumberMode="static"
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      muiSearchTextFieldProps={{
        placeholder: t`Search`,
        style: { marginTop: '5px' },
      }}
      positionToolbarAlertBanner="bottom"
      enableFilters={true}
      renderToolbarInternalActions={({ table }) => (
        <Box display="flex" gridGap="xs">
          <MRT_ToggleGlobalFilterButton /*sx={{ color: `${darkGray} !important` }}*/ table={table} />
          {showFilters && <MRT_ToggleFiltersButton /*sx={{ color: `${darkGray} !important` }}*/ table={table} />}
          <Hidden smDown>
            <MRT_FullScreenToggleButton
              /*sx={{ color: `${darkGray} !important` }}*/
              table={table}
              onClick={() => {
                const { getState, setIsFullScreen } = table
                const { isFullScreen } = getState()

                setIsFullScreen(!isFullScreen)

                if (!isFullScreen) {
                  document.querySelectorAll<HTMLElement>('.nav')[0].style.zIndex = '0'
                  document.querySelectorAll<HTMLElement>('.layout__header')[0].style.zIndex = '0'
                } else {
                  document.querySelectorAll<HTMLElement>('.nav')[0].style.zIndex = '10'
                  document.querySelectorAll<HTMLElement>('.layout__header')[0].style.zIndex = '100'
                }
              }}
            />
          </Hidden>
        </Box>
      )}
      muiTableBodyProps={{
        sx: (theme) => ({
          '& > tr:hover > td': {
            backgroundColor: '#F2F8FF',
            '& .MuiFilledInput-root': {
              backgroundColor: 'white !important',
            },
          },
        }),
      }}
      muiTableHeadRowProps={{
        sx: {
          boxShadow: 'none',
        },
      }}
      muiTableHeadCellProps={{
        sx: (theme) => {
          return {
            paddingTop: '16px !important',
            paddingBottom: '16px !important',
            lineHeight: '24px !important',
            fontSize: '14px !important',
            color: darkBlue,
            fontFamily: variables.font_family,
            borderColor: darkGray,
          }
        },
      }}
      muiTableBodyCellProps={{
        sx: (theme) => ({
          paddingTop: '8px !important',
          paddingBottom: '8px !important',
          lineHeight: '40px !important',
          fontSize: '14px !important',
          color: darkBlue,
          fontFamily: variables.font_family,
          borderColor: darkGray,
        }),
      }}
      muiTableDetailPanelProps={{
        sx: {
          backgroundColor: `${gray} !important`,
          padding: 0,
        },
      }}
      muiBottomToolbarProps={{
        sx: {
          boxShadow: 'none',
          '& .MuiTablePagination-select': {
            fontSize: '14px !important',
            //paddingBottom: '2px',
            color: darkBlue,
            fontFamily: variables.font_family,
            borderColor: 'transparent !important',
            backgroundColor: 'white !important',
            borderRadius: '0px !important',
          },
          '& .MuiTablePagination-selectLabel': {
            fontSize: '14px !important',
            color: darkBlue,
            position: 'relative',
            top: '-1px',
            fontFamily: variables.font_family,
          },
          '& .MuiTablePagination-displayedRows': {
            fontSize: '14px !important',
            fontWeight: 'bold',
            color: darkBlue,
            fontFamily: variables.font_family,
          },
          '& .MuiTablePagination-menuItem': {
            display: 'block !important',
            textAlign: 'center !important',
          },
        },
      }}
      muiToolbarAlertBannerProps={{
        sx: (theme) => ({
          fontSize: '14px !important',
          color: darkBlue,
          fontFamily: variables.font_family,
        }),
      }}
      muiTopToolbarProps={{
        sx: {
          '& > .MuiBox-root': {
            alignItems: 'center',
            padding: '0px',
            '.MuiDialog-scrollPaper &': {
              padding: '8px',
            },
          },
        },
      }}
      localization={{
        rowsPerPage: t`Rows per page`,
        noResultsFound: t`No matches found.`,
        noRecordsToDisplay: t`No matches found.`,
        search: t`Search`,

        clearSort: t`Clear sort`,
        clearFilter: t`Clear filter`,
        hideColumn: t`Hide {column} column`,
        showAllColumns: t`Show all columns`,
        sortByColumnAsc: t`Sort by {column} ascending`,
        sortByColumnDesc: t`Sort by {column} descending`,
        filterByColumn: t`Filter by {column}`,
        selectedCountOfRowCountRowsSelected: t`{selectedCount} of {rowCount} row(s) selected`,
        of: t`of`,

        showHideSearch: '',
        showHideFilters: '',
        clearSearch: '',
        sortedByColumnAsc: '',
        sortedByColumnDesc: '',
        columnActions: '',
        goToFirstPage: '',
        goToLastPage: '',
        goToNextPage: '',
        goToPreviousPage: '',
        toggleSelectAll: '',
        toggleSelectRow: '',
        toggleFullScreen: '',

        expand: '', //t`Expand`,
        expandAll: '', //t`Expand all`,
        collapse: '', //t`Collapse`,
        collapseAll: '', //t`Collapse all`,
      }}
      {...otherProps}
    />
  )
}

export default YumTable
